module.exports = __webpack_public_path__ + "hbomaxar-static/media/Witches_Rats.35c63ab0.png";